import useDefinedContext from "hooks/useDefinedContext";
import HyroxMetadataContext from "../contexts/HyroxMetadataContext";

function useHyroxMetadata() {
  return useDefinedContext(HyroxMetadataContext);
}

export default useHyroxMetadata;
